import { cn } from "@/lib/utils";

interface MarketingScreenshotFrameProps {
  src: string;
  alt: string;
  className?: string;
}

export function MarketingScreenshotFrame({ src, alt, className }: MarketingScreenshotFrameProps) {
  return (
    <div 
      className={cn(
        "aspect-[16/10] rounded-2xl border border-black/5 shadow-lg shadow-black/10 overflow-hidden bg-white/70",
        className
      )}
    >
      <img 
        src={src} 
        alt={alt}
        className="w-full h-full object-contain"
        loading="lazy"
      />
    </div>
  );
}
